import { render, staticRenderFns } from "./MarketingCampaignTabs.vue?vue&type=template&id=5520767f&scoped=true"
import script from "./MarketingCampaignTabs.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignTabs.vue?vue&type=script&lang=js"
import style0 from "./MarketingCampaignTabs.vue?vue&type=style&index=0&id=5520767f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520767f",
  null
  
)

export default component.exports